import React, { FC } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { LKButton } from 'loankeeper-common/components'
import { translate as translateBase } from 'loankeeper-common/helpers'
import { loadFont } from 'loankeeper-common/helpers/styles'
import { loadingActions } from 'loankeeper-common/components/hocs/LazyLoading'

import LKModal, { actions as LKModalActions } from '../../shared/LKModal'
import { sendLoginSms } from '../../../store/auth'
import { FORM_NAME, SMS_CONFIRM } from '../constants'
import { AppDispatch } from 'src/store/index.d'

const translate = (key: string): string => translateBase(`frm_web_messages-${key}`)

const selectFormValue = formValueSelector(FORM_NAME)

const ButtonWrapper = styled(LKButton)`
  &.ui.button {
    ${(props) => loadFont(props.theme.buttonFont || '13px BPG Algeti')};
    margin-left: 10px;
    width: calc(50% - 5px);
    margin-right: 0px;
    box-sizing: border-box;
  }
`

export const SendLoginPinButton: FC<{ disabled: boolean; text: string }> = ({ disabled, text }) => {
  const dispatch = useDispatch<AppDispatch>()

  const username: string = useSelector((state) => selectFormValue(state, 'username'))
  const password: string = useSelector((state) => selectFormValue(state, 'password'))

  const handleClick = () => {
    dispatch(
      LKModalActions.openConfirmation(SMS_CONFIRM, {
        message: translate('MSG_SMS_OTP_SENT_CLIENT_CELLPHONE'),
      }),
    )
  }

  const handleSendSmsLoginConfirm = async () => {
    loadingActions.start()

    await dispatch(
      sendLoginSms({
        username,
        password,
      }),
    )

    loadingActions.stop()
  }

  return (
    <>
      <ButtonWrapper alias="mail" type="primary" disabled={disabled} onClick={handleClick}>
        {/* {translate('MSG_SMS_OTP_GET')} */}
        {text}
      </ButtonWrapper>
      {/* @ts-ignore */}
      <LKModal.Confirmation name={SMS_CONFIRM} onConfirm={handleSendSmsLoginConfirm} />
    </>
  )
}
